/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropruleshint2Inputs */

const en_dropruleshint2 = /** @type {(inputs: Dropruleshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional. Users must satisfy every rule to enter the drop.`)
};

const de_dropruleshint2 = /** @type {(inputs: Dropruleshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional. Nutzer müssen alle Regeln erfüllen, um am Drop teilzunehmen.`)
};

/**
* | output |
* | --- |
* | "Optional. Users must satisfy every rule to enter the drop." |
*
* @param {Dropruleshint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropruleshint2 = /** @type {((inputs?: Dropruleshint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropruleshint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropruleshint2(inputs)
	return de_dropruleshint2(inputs)
});
export { dropruleshint2 as "dropRulesHint" }